import { Col, Divider, Form, Modal, Radio, Row, Typography } from "antd";
import GeneralCardsLastUsageDateInput from "apps/Common/GeneralCardsLastUsageDateInput";
import GeneralPaymentInput from "apps/Common/GeneralPaymentInput";
import GeneralPaymentSecurityCode from "apps/Common/GeneralPaymentSecurityCode";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaInput } from "apps/Common/MazakaInput";
import useMazakaForm from "hooks/useMazakaForm";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { RootState } from "store/Reducers";
import { createPayment, getInstallmentAccordingCard } from "../../Services";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";

import { useState } from "react";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import { RadioChangeEvent } from "antd/lib";
import SuccessPayment from "./SuccessPayment";
import paymentEndPoints from "apps/CustomerPanel/Invoice/EndPoints";
import { useQueryClient } from "react-query";
import PriceFormatter from "apps/Common/PriceFormatter";
import ContractCheckbox from "./ContractCheckbox";
import { editAdvert } from "../../Services";
import { getAdvertDetails } from "apps/RealState/Details/Services";

const CardInfoes = () => {
  const queryClient = useQueryClient();
  const [isShowAgreement,setIsShowAgreement] = useState(false)
  const { Text } = Typography;
  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);

  const { userInfoes } = useSelector((state: RootState) => state.profile);
  const { selectedPackages, adData } = useSelector((state: RootState) => state.ad);
  const [installmentData, setInstallmentData] = useState<any>(null);
  const [bankInfoes, setBankInfoes] = useState<any>(null);
  const [isShowSuccessPaymentModal, setIsShowSuccessPaymentModal] =
    useState(false);



    const handleOnFinish = async () => {
  mazakaForm.setLoading();
  const formValues = form.getFieldsValue();
  const selectedPackageId = selectedPackages?.package?.id;
  const dopingList =
    selectedPackages?.dopings?.map((item: any) => item.id) || [];
  const packageListId = [selectedPackageId, ...dopingList];
  
  let data: any = {
    creditCard: {
      cardholderName: null,
      cardNumber: null,
      cvV2: null,
      expirationYear: null,
      expirationMonth: null,
    },
    userPackage: { packageIdList: packageListId },
    userId: userInfoes?.id,
    advertId: selectedPackages?.advertId,
  };
  
  console.log("data1", data);
  console.log("sele", selectedPackages);

  if (installmentData?.installment?.length > 0) {
    if (bankInfoes) {
      data["bankId"] = bankInfoes?.bankId;
      data["installment"] = bankInfoes.installment;
    } else {
      mazakaForm.setFailed(
        2000,
        "Taksit Seçeneklerden birini seçmeniz lazım"
      );
      openNotificationWithIcon(
        "error",
        "Taksit Seçeneklerden birini seçmeniz lazım"
      );
      return false;
    }
  }

  data["creditCard"]["cardholderName"] = formValues["cardholderName"];
  data["creditCard"]["cardNumber"] = formValues["cardNumber"].replace(
    /-/g,
    ""
  );
  data["creditCard"]["cvV2"] = formValues["cvV2"].replace(/-/g, "");
  data["creditCard"]["expirationYear"] =
    formValues["expiredDate"].split("/")[0];
  data["creditCard"]["expirationMonth"] =
    formValues["expiredDate"].split("/")[1];

  try {
    // ÖNCELİKLE İLAN GÜNCELLEMESİ YAP
    const advertId = selectedPackages?.advertId; // veya searchParams'dan alabilirsiniz
    if (advertId) {
      // adData'yı status: 1 ve isCompleted: true ile güncelle
      let currentAdData = adData;
      if (!currentAdData) {
        const response = await getAdvertDetails(advertId);
        currentAdData = response.data;
      }
      const updatedAdData = {
        ...currentAdData, // adData'yı useSelector ile almanız gerekecek
        isCompleted: true
      };
      
      const editResponse = await editAdvert(updatedAdData);
      console.log("Edit response:", editResponse);
    }

    // DAHA SONRA ÖDEME İŞLEMİNİ YAP
    await createPayment(data);
    await setIsShowSuccessPaymentModal(true);
    
    queryClient.resetQueries({
      queryKey: paymentEndPoints.getInvoiceList,
      exact: false,
    });

    mazakaForm.setSuccess(
      2000,
      () => "İlanız oluşturuldu. Onaya yönetime gönderilecektir"
    );
    
  } catch (error: any) {
    mazakaForm.setFailed(2000, error?.message);
    openNotificationWithIcon("default", error?.message);
    console.log("İlan güncelleme veya ödeme işlemi sırasında hata:", error);
  }
};

  // const handleOnFinish = async () => {
  //   mazakaForm.setLoading();
  //   const formValues = form.getFieldsValue();
  //   const selectedPackageId = selectedPackages?.package?.id;
  //   const dopingList =
  //     selectedPackages?.dopings?.map((item: any) => item.id) || [];
  //   const packageListId = [selectedPackageId, ...dopingList];
  //   let data: any = {
  //     creditCard: {
  //       cardholderName: null,

  //       cardNumber: null,
  //       cvV2: null,
  //       expirationYear: null,
  //       expirationMonth: null,
  //     },
  //     userPackage: { packageIdList: packageListId },
  //     userId: userInfoes?.id,
  //     advertId: selectedPackages?.advertId,
  //   };
  //   console.log("data1",data)
  //   console.log("sele",selectedPackages)

  //   if (installmentData?.installment?.length > 0) {
  //     if (bankInfoes) {
  //       data["bankId"] = bankInfoes?.bankId;
  //       data["installment"] = bankInfoes.installment;
  //     } else {
  //       mazakaForm.setFailed(
  //         2000,
  //         "Taksit Seçeneklerden birini seçmeniz lazım"
  //       );
  //       openNotificationWithIcon(
  //         "error",
  //         "Taksit Seçeneklerden birini seçmeniz lazım"
  //       );
  //       return false;
  //     }
  //   }


  //   data["creditCard"]["cardholderName"] = formValues["cardholderName"];
  //   data["creditCard"]["cardNumber"] = formValues["cardNumber"].replace(
  //     /-/g,
  //     ""
  //   );
  //   data["creditCard"]["cvV2"] = formValues["cvV2"].replace(/-/g, "");
  //   data["creditCard"]["expirationYear"] =
  //     formValues["expiredDate"].split("/")[0];
  //   data["creditCard"]["expirationMonth"] =
  //     formValues["expiredDate"].split("/")[1];


  //   try {
     
  //     await createPayment(data);
  //     await setIsShowSuccessPaymentModal(true);
  //     queryClient.resetQueries({
  //       queryKey: paymentEndPoints.getInvoiceList,
  //       exact: false,
  //     });

  //     mazakaForm.setSuccess(
  //       2000,
  //       () => "İlanıız oluşturuldu.Onaya yönetime gönderilecektir"
  //     );
      
  //   } catch (error: any) {
  //     mazakaForm.setFailed(2000, error?.messsage);
  //     openNotificationWithIcon("default", error?.messsage);
  //     console.log("somethings wrong during create payment", error);
  //   }
  // };
  const getInstallmentList = async (cartNumber: string) => {
    try {
      const selectedPackageId = selectedPackages?.package?.id;
      const dopingList =
        selectedPackages?.dopings?.map((item: any) => item.id) || [];
      const packageListId = [selectedPackageId, ...dopingList];
      let data = {
        binNumber: cartNumber,
        packageIdList: packageListId,
      };
      const response = await getInstallmentAccordingCard(data);

      if (response?.data) {
        setInstallmentData(response?.data);
        if (response?.data.installment?.length > 0) {
          const firstInstallment = response?.data.installment[0];
          setBankInfoes({
            bankId: response?.data.bankId,
            installment: firstInstallment.bankInstallment,
            id: firstInstallment.id,
          });

          // Radio.Group'un güncellenmesi için state'i key olarak ayarla
          setRadioGroupKey(firstInstallment.id);
        }
      } else {
        setInstallmentData(null);
      }
    } catch (error: any) {
      openNotificationWithIcon("default", error?.message);
      console.log("Somethings wrong during getting installment", error);
    }
  };

  // Radio Group için bir key state'i ekleyelim
  const [radioGroupKey, setRadioGroupKey] = useState<number | null>(null);

  const onChange = (e: RadioChangeEvent) => {
    const selectedInstallment = installmentData?.installment.find(
      (item: any) => item.id === e.target.value
    );
    if (selectedInstallment) {
      setBankInfoes({
        bankId: selectedInstallment.bankId,
        installment: selectedInstallment.bankInstallment,
        id: selectedInstallment.id,
      });

      // Yeni seçilen taksiti güncellemek için key'i de değiştir
      setRadioGroupKey(selectedInstallment.id);
    }
  };



  return (
    <>
      <MazakaForm
        submitButtonVisible={false}
        form={form}
        onFinish={handleOnFinish}
      >
        <Row gutter={[10, 20]}>
          <Col xs={24} className="flex justify-center">
            <Text className="!text-2xl !font-bold !text-black">
              Ödemenızı Yapınız
              <span className="mt-2 block h-1 w-10 bg-teal-600 sm:w-20"></span>
            </Text>
          </Col>

          <MazakaInput
            xs={24}
            name={"cardholderName"}
            label={"Kart Üzerindeki İsim"}
            className="!m-0"
            inputClassName=" !p-2"
            placeholder={"Kart Üzerindeki İsim"}
            rules={[{ required: true, message: "" }]}
          />

          <GeneralPaymentInput
            inputClassName=" !p-2"
            name="cardNumber"
            xs={24}
            label={"Kart Numarası"}
            className="!m-0"
            rules={[{ required: true, message: "" }]}
            getInstallmentList={getInstallmentList}
          />
          <GeneralCardsLastUsageDateInput
            inputClassName=" !p-2"
            name="expiredDate"
            xs={24}
            lg={12}
            label={"Son Kullanma Tarihi"}
            className="!m-0"
            rules={[{ required: true, message: "" }]}
          />

          <GeneralPaymentSecurityCode
            xs={24}
            lg={12}
            name={"cvV2"}
            label={"CCV"}
            className="!m-0"
            inputClassName=" !p-2"
            rules={[{ required: true, message: "" }]}
          />

          <ContractCheckbox />

          {installmentData && (
            <Row gutter={[0, 20]}>
              <>
                <Col xs={24}>
                  <div>
                    <LazyLoadImage
                      wrapperWidth="70px"
                      wrapperHeight="70px"
                      src={installmentData?.icon?.fullPath}
                      alt=""
                      imageClassName="!rounded-md"
                    />
                  </div>
                  <div>
                    <div>
                      <Text>{installmentData.name}</Text>
                    </div>
                  </div>
                </Col>
                <Col xs={24}>
                  <Divider className="!m-0" />
                </Col>
                <Col xs={24}>
                  <Row>
                    <Col xs={24}>
                      <Row>
                        <Col xs={24} lg={6}>
                          <Text>Taksit Sayisi</Text>
                        </Col>
                        <Col xs={24} lg={6}>
                          <Text>Taksit Tutari</Text>
                        </Col>
                        <Col xs={24} lg={6}>
                          <Text>Toplam Tutar</Text>
                        </Col>
                        <Col xs={24}>
                          <Divider />
                        </Col>
                      </Row>
                    </Col>
                    <Col xs={24}>
                      <Row gutter={[0, 20]}>
                        {installmentData?.installment?.length > 0 ? (
                          <>
                            <Radio.Group
                              key={radioGroupKey}
                              onChange={onChange}
                              className="!w-full !flex-col gap-5"
                            >
                              {installmentData?.installment.length > 0 ? (
                                <>
                                  <Radio.Group
                                    onChange={onChange}
                                    value={bankInfoes?.id}
                                    className="!w-full !flex-col gap-5"
                                  >
                                    {installmentData?.installment.map(
                                      (item: any) => {
                                        return (
                                          <Col
                                            xs={24}
                                            key={item.bankInstallment}
                                            className="!mb-4"
                                          >
                                            <Row gutter={[0, 0]}>
                                              <Col xs={24} lg={6}>
                                                <Radio
                                                  value={item.id}
                                                  className="!w-full"
                                                >
                                                  <Text>{item.title}</Text>
                                                </Radio>
                                              </Col>
                                              <Col xs={24} lg={6}>
                                                <Text>
                                                  {item?.installmentAmount?.toFixed(
                                                    2
                                                  ) || ""}
                                                  TL
                                                </Text>
                                              </Col>
                                              <Col xs={24} lg={6}>
                                                <Text>
                                                  <PriceFormatter
                                                    inputPrice={
                                                      item?.maxPrice || 0
                                                    }
                                                  />
                                                  TL
                                                </Text>
                                              </Col>
                                            </Row>
                                          </Col>
                                        );
                                      }
                                    )}
                                  </Radio.Group>
                                </>
                              ) : (
                                <p>Bu bankaya ait taksit bulunamadı</p>
                              )}
                            </Radio.Group>
                          </>
                        ) : (
                          <p>Bu bankaya ait taksit bulunamadı</p>
                        )}
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </>
            </Row>
          )}

          <Col xs={24} className="!flex items-center">
            <MazakaButton
              className="!p-4 !bg-[#FFC502] !text-black"
              htmlType="submit"
              block
              processType={formActions.submitProcessType}
            >
              Ödeme
            </MazakaButton>
          </Col>
        </Row>
      </MazakaForm>
      <Modal open={isShowSuccessPaymentModal} closable={false} footer={false}>
        <SuccessPayment
          setIsShowSuccessPaymentModal={setIsShowSuccessPaymentModal}
        />
      </Modal>
    </>
  );
};

export default CardInfoes;
